// src/components/ui/textarea.jsx
import React from "react";
import { cn } from "../../lib/utils";

export function Textarea({ className, ...props }) {
    return (
        <textarea
            className={cn(
                "min-h-[104px] w-full rounded-lg border border-zinc-200 bg-white px-3.5 py-2.5 text-sm leading-relaxed text-zinc-900 outline-none transition-all duration-200 placeholder:text-zinc-400 focus:border-brand-400 focus:ring-4 focus:ring-brand-500/15 dark:border-zinc-800 dark:bg-zinc-950/60 dark:text-zinc-100 dark:placeholder:text-zinc-500 dark:focus:border-brand-500 dark:focus:ring-brand-500/20",
                className
            )}
            {...props}
        />
    );
}
